import type { FC } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import { isMatchFinished } from 'app/utils/match';
import { getTeamsScores } from 'app/components/MatchPreview/utils';
import type { MatchPreviewData, MatchPreviewTeam } from 'app/components/MatchPreview/types';

import style from './style.scss';

interface Props {
  match: MatchPreviewData;
  teams: [MatchPreviewTeam, MatchPreviewTeam];
  valueClassName: string;
  compact?: boolean;
}

const scoreClassNameMap = {
  win: style.teamValue_win,
  lose: style.teamValue_lose,
  void: style.teamValue_void,
  draw: style.teamValue_draw
};

const MatchTeamsScore: FC<Props> = ({ match, teams, valueClassName, compact }) => {
  const [t] = useTranslation();
  const [teamAScore, teamBScore] = getTeamsScores(match, teams[0], teams[1]);

  return (
    <>
      <span
        className={classnames(valueClassName, scoreClassNameMap[teamAScore.type], {
          [style.compactScore]: compact
        })}
      >
        {teamAScore.value}
      </span>
      {isMatchFinished(match) && match.draw ? (
        <span className={classnames(style.draw, { [style.compact]: compact })}>
          {t('events-match_tie')}
        </span>
      ) : (
        <span className={classnames(style.versus, { [style.compact]: compact })}>
          {t('events-match_versus')}
        </span>
      )}
      <span
        className={classnames(valueClassName, scoreClassNameMap[teamBScore.type], {
          [style.compactScore]: compact
        })}
      >
        {teamBScore.value}
      </span>
    </>
  );
};

MatchTeamsScore.displayName = 'MatchTeamsScore';

export default MatchTeamsScore;
